import * as React from "react";
import { renderLiveScore, renderKickOffState } from "../RenderMethods";
export const renderLiveDetails = (props, componentPrefix) => React.createElement(React.Fragment, null,
    renderLiveScore(props.event, componentPrefix),
    props.event.isInKickOffState && renderKickOffState(props, componentPrefix));
//# sourceMappingURL=renderLiveDetails.js.map